import { useAppSelector } from "redux-share";
import { conditions, controllbarIconSize } from "../../../../../helpers";
import { ConditionName, IMultiLiveIconProps } from "../../../../../interfaces";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const MultiLivesIcon = dynamic(() => import("../../icon-components/multiLiveIcon"));

const MultiLiveIcon = (props: IMultiLiveIconProps) => {
    useAppSelector(({ videoData: { isComplexPortrait } }) => ({ isComplexPortrait }), shallowEqual);

    let icon = <></>;

    if (conditions(ConditionName.isSplusEnvironment))
        icon = (
            <i
                className={`fa-solid fa-camera-rotate pl-cursor-pointer ${
                    conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                        ? controllbarIconSize.otherFontAwesome
                        : controllbarIconSize.miniPlayerFontAwesome
                }}`}
                {...props}
            />
        );
    else
        icon = (
            <div className="pl-cursor-pointer" {...props}>
                <MultiLivesIcon
                    className={`${conditions(ConditionName.isComplexPortrait) ? "pl-fill-gray-800 dark:pl-fill-dark-5" : `pl-fill-dark-5`}`}
                    width={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    height={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    strokeColor={!conditions(ConditionName.isComplexPortrait) ? "black" : ""}
                />
            </div>
        );

    if (conditions(ConditionName.isComplexPortrait))
        icon = (
            <div
                className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer"
                onClick={props.onClick}
            >
                {icon}
                <span className="pl-whitespace-nowrap">چند دوربینی</span>
            </div>
        );

    return <>{icon}</>;
};

export default MultiLiveIcon;
